import { PendingVirtualGraph } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export const pendingVirtualGraphsSelector =
  (projectId: string) =>
  (state: ReduxState): PendingVirtualGraph[] | undefined =>
    state.projects.pendingVirtualGraphsByProjectId[projectId];
